import { Injectable } from '@angular/core';
import { Contact } from '../entities/Contact';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Trame } from '../entities/trame';
import { environment } from 'src/environments/environment';
import { UserService } from 'src/app/admin/core/services/user.service';

@Injectable({
  providedIn: 'root'
})
export class EmailService {
  usermail:string
  constructor(private readonly _httpClient: HttpClient, private userService: UserService) { 
    this.userService.getCurrentUser().then(user => {
      this.usermail = user.email;
    })
  }

  sendContactMail(contact: Contact) {
    let message = `<div style="text-align:left; font-family: Roboto;">
                    <h2 style="text-align:left">Une nouvelle demande de contact sur le site befor.fr</h2>
                      <div style="margin-top: 10px;"><strong>Société : </strong>${contact.companyName ? contact.companyName : '-'}</div>
                      <div style="margin-top: 10px;"><strong>Nom : </strong>${contact.lastName ? contact.lastName : '-'}</div>
                      <div style="margin-top: 10px;"><strong>Prénom : </strong>${contact.firstName ? contact.firstName : '-'}</div>
                      <div style="margin-top: 10px;"><strong>Fonction : </strong>${contact.companyFunction ? contact.companyFunction : '-'}</div>
                      <div style="margin-top: 10px;"><strong>Adresse : </strong>${contact.address ? contact.address : '-'}</div>
                      <div style="margin-top: 10px;"><strong>Code postal : </strong>${contact.postcode ? contact.postcode : '-'}</div>
                      <div style="margin-top: 10px;"><strong>Ville : </strong>${contact.city ? contact.city : '-'}</div>
                      <div style="margin-top: 10px;"><strong>Pays : </strong>${contact.country ? contact.country : '-'}</div>
                      <div style="margin-top: 10px;"><strong>Email : </strong><a href="mailto:${contact.email}">${contact.email}</a></div>
                      <div style="margin-top: 10px;"><strong>Téléphone : </strong><a href="tel:${contact.phone}">${contact.phone ? contact.phone : '-'}</a></div>
                      <div style="margin-top: 10px;"><strong>Objet : </strong>${contact.subject}</div>
                      <div style="margin-top: 10px;"><strong>Message : </strong>${contact.message}</div>
                  </div>`;

    let bodyContactMail = {
      mailsubject: contact.subject,
      mailfrom: contact.email,
      
      mailcontent: message
    }

    const options: any = {};
    options.headers = new HttpHeaders().append('Frontend-Request', 'true');
    return this._httpClient.post<any>(
      `/email/sendMail`, bodyContactMail,
      options
    );
  }

  sendFrameValidationMail(mailfrom: string, trame: Trame) {
    let message = `<div style="text-align:left; font-family: Roboto;">
                    <h2 style="text-align:left">Une nouvelle trame a été importée sur PIA</h2>
                      <div style="margin-top: 10px;"><strong>Fournisseur : </strong>${trame.supplier ? (trame.supplier.value ? trame.supplier.value : trame.supplier) : '-'}</div>
                      <div style="margin-top: 10px;"><strong>Date de soumission : </strong>${trame.submissionDate ? trame.submissionDate.toLocaleString('fr-FR') : '-'}</div>
                      <div style="margin-top: 10px;"><strong>Date de publication : </strong>${trame.publicationDate ? trame.publicationDate.toLocaleString('fr-FR') : '-'}</div>
                  </div>`;

    let bodyContactMail = {
      mailsubject: `PIA - Trame ${this.getFrameType(trame)} à valider`,
      mailfrom: mailfrom,
      mailcontent: message,
      tramValidationEmailTemplate:environment.tramValidationEmailTemplate,
    }

    
    const options: any = {};
    options.headers = new HttpHeaders().append('Frontend-Request', 'true');
    return this._httpClient.post<any>(
      `/email/sendMail`, bodyContactMail,
      options
    );
  }

  sendBasicMail(bodyContactMail: any) {
    const options: any = {};
    options.headers = new HttpHeaders().append('Frontend-Request', 'true');
    return this._httpClient.post<any>(
      `/email/sendMail`, bodyContactMail,
      options
    );
  }

  getFrameType(trame: Trame) {
    return trame?.frameType ? (trame.frameType.value ? trame.frameType.value.toLowerCase() : trame.frameType.toLowerCase()) : '';
  }

  getSupplier(trame: Trame) {
    return trame.supplier ? (trame.supplier.value ? trame.supplier.value : trame.supplier) : '-';
  }

  sendMailWithAttachment(file: File) { 
    const options: any = {};
    const formData = new FormData();
    formData.append('file', file);
    options.headers = new HttpHeaders().append('Frontend-Request', 'true');
    return this._httpClient.post<any>(
      `/email/sendMailWithAttachment`, formData,
      options
    );
  }


  sendFrameAccepted(mailTo: string, trame: Trame, date: Date) {
    let message = `<div style="text-align:left; font-family: Roboto;">
                    <h2 style="text-align:left">Une nouvelle trame validée sur PIA</h2>
                      <div style="margin-top: 10px;"><strong>Fournisseur : </strong>${this.getSupplier(trame)}</div>
                      <div style="margin-top: 10px;"><strong>Date de publication : </strong>${date ? date.toISOString().split('T')[0] : '-'}</div>
                  </div>`;

    let bodyContactMail = {
      mailsubject: `PIA - Trame ${this.getFrameType(trame)} validée`,
      mailto: mailTo,
      mailfrom:this.usermail,
      tramValidationEmailTemplate:environment.tramValidationEmailTemplate,
      mailcontent: message
    }

    const options: any = {};
    options.headers = new HttpHeaders().append('Frontend-Request', 'true');
    return this._httpClient.post<any>(
      `/email/sendMail`, bodyContactMail,
      options
    );
  }


  sendFrameRefused(mailTo: string, trame: Trame, reason: string) {
    let message = `<div style="text-align:left; font-family: Roboto;">
                    <h2 style="text-align:left">Une nouvelle trame refusée sur PIA</h2>
                      <div style="margin-top: 10px;"><strong>Fournisseur : </strong>${this.getSupplier(trame)}</div>
                      <div style="margin-top: 10px;"><strong>Date de soumission : </strong>${trame.submissionDate ? trame.submissionDate.toLocaleString('fr-FR') : '-'}</div>
                      <div style="margin-top: 10px;"><strong>Date de publication : </strong>${trame.publicationDate ? trame.publicationDate.toLocaleString('fr-FR') : '-'}</div>
                      <div style="margin-top: 10px;"><strong>Raison : </strong>${reason ? reason : '-'}</div>
                  </div>`;

    let bodyContactMail = {
      mailsubject: `PIA - Trame ${this.getFrameType(trame)} refusée`,
      mailto: mailTo,
      mailfrom:this.usermail,
      tramValidationEmailTemplate:environment.tramValidationEmailTemplate,
      mailcontent: message
    }

    const options: any = {};
    options.headers =  new HttpHeaders({
      'Content-Type': 'application/json; charset=UTF-8',
      'Accept-Charset': 'UTF-8',
      'Frontend-Request':'true'
    });
  // new HttpHeaders().append('Frontend-Request', 'true');
    return this._httpClient.post<any>(
      `/email/sendMail`, bodyContactMail,
      options
    );
  }
}
